import { Dialog as SheetPrimitive } from 'bits-ui';
import Content from './sheet-content.svelte';

const Root = SheetPrimitive.Root;
const Trigger = SheetPrimitive.Trigger;
const Close = SheetPrimitive.Close;
const Portal = SheetPrimitive.Portal;
const Title = SheetPrimitive.Title;
const Description = SheetPrimitive.Description;

export {
  Root,
  Trigger,
  Close,
  Portal,
  Content,
  Title,
  Description,
  Root as Sheet,
  Trigger as SheetTrigger,
  Close as SheetClose,
  Portal as SheetPortal,
  Content as SheetContent,
  Title as SheetTitle,
  Description as SheetDescription,
};
